import { doc, setDoc } from 'firebase/firestore';
import { ReportSettings } from '../providers/reports/types';
import { ISettingsTemplate } from '../providers/settings/reports/types';
import { userAsPromise } from '../providers/userProvider';

/**
 * @description shares template with users by writing new template to them
 * @param template {ITemplate} template to be shared
 * @param user {IUser} user that will receive the template
 */
export const shareTemplate = async (
  reportTypeId: string,
  template: ISettingsTemplate<ReportSettings>,
  userId: string
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `userProfiles/${userId}/settings/${reportTypeId}/templates/${template.id}`
    ),
    { ...template, shared: true },
    { merge: true }
  );
};
